import { useUserStoreWidthOut } from '@ess-v3/store/user'
import { storage } from '@ess-v3/utils/storage'
import type { Router } from 'vue-router'

export async function createRouterGuards(router: Router) {
  const userStore = useUserStoreWidthOut()
  if (!userStore.getToken) {
    userStore.setToken(storage.getCookie('clientauthentication'))
  }
  router.beforeEach(async (_to, _from, next) => {
    if (userStore.getToken && !userStore.getUserInfo) {
      await userStore.GetInfo()
    }

    next()
  })
}
